<form
  [formGroup]="reportsForm"
  class="form-container">
<form
  [formGroup]="reportsForm"
  class="form-container">

  <fieldset
    *ngFor="let fieldSet of fieldSets; index as i"
    [ngClass]="{
      'border': !!fieldSet.legend || !!fieldSet.hint,
      'error-fieldset-border': reportsForm.errors?.['required']?.[fieldSet.name] && submitCount > 0
    }">

    <legend class="legend" [ngClass]="{ 'error-text': reportsForm.errors?.['required']?.[fieldSet.name] && submitCount > 0 }">
      {{ fieldSet.legend }}
    </legend>

    @if (reportsForm.errors?.['required']?.[fieldSet.name] && submitCount > 0) {
      <mat-error class="fieldset-hint">
        {{ fieldSet.hint }}
      </mat-error>
    } @else if (fieldSet.legend || fieldSet.hint) {
      <mat-hint class="fieldset-hint">
        {{ fieldSet.hint }}
      </mat-hint>
    }

    @if (fieldSet.fields && fieldSet.fields.length) {

      @for (ctrl of fieldSet.fields; track ctrl.name) {

        @if (ctrl.type === 'text' && ctrl.search) {
          <app-type-ahead
            class="field"
            [ctrl]="ctrl"
            [containErrors]="(reportsForm.get(ctrl.name)?.hasError('required') && submitCount > 0) === true"
            [countError]="!!reportsForm.get(ctrl.name)?.hasError('maxSelectionLimit')">
          </app-type-ahead>
        }

        @if (ctrl.type === 'text' && !ctrl.search) {
          <app-text-field
            class="field"
            [name]="ctrl.name"
            [label]="ctrl.label"
            [value]="ctrl.value ?? ''"
            [customErrorMessage]="reportsForm.get(ctrl.name)?.hasError('required') && submitCount > 0 ? ctrl.label + ' is required' : ''"
            [isRequired]="ctrl.required === true"
            (inputEvent)="updateControlValue($event)">
        </app-text-field>
        }
        @if (ctrl.type === 'text-area') {
          <app-text-area
            class="field"
            [name]="ctrl.name"
            [label]="ctrl.label"
            [value]="ctrl.value ?? ''"
            [customErrorMessage]="reportsForm.get(ctrl.name)?.hasError('required') && submitCount > 0 ? ctrl.label + ' is required' : ''"
            [isRequired]="ctrl.required === true"
            (inputEvent)="updateControlValue($event)">
        </app-text-area>
        }

        @if (ctrl.type === 'date') {
          <app-date-range-field
            class="field"
            [name]="ctrl.name"
            [value]="ctrl.value ?? ''"
            [label]="ctrl.label"
            [isRequired]="ctrl.required === true"
            [isDateAllowed]="ctrl.dateAllowed === true"
            [customErrorMessage]="
            reportsForm.get(ctrl.name)?.hasError('required') && submitCount > 0 ? ctrl.label + ' is required' :
            reportsForm.get(ctrl.name)?.hasError('InvalidDateRange') && submitCount > 0 ? 'Invalid Date Range' :''"
            (dateRangeFieldEvent)="updateControlValue($event)">
          </app-date-range-field>
        }
        @if (ctrl.type === 'period') {
          <app-date-field
            class="field"
            [name]="ctrl.name"
            [value]="ctrl.value ?? ''"
            [label]="ctrl.label"
            [isRequired]="ctrl.required === true"
            [customErrorMessage]="
            reportsForm.get(ctrl.name)?.hasError('required') && submitCount > 0 ? ctrl.label + ' is required' :
            reportsForm.get(ctrl.name)?.hasError('invalidDate') ? 'Invalid Date' :''"
            (dateFieldEvent)="updateControlValue($event)">
          </app-date-field>
        }

        @if (ctrl.type === 'radio') {
          <app-radio-button-field
            class="field"
            [name]="ctrl.name"
            [value]="ctrl.value || ''"
            [label]="ctrl.label"
            [defaultOption]="ctrl.defaultOption"
            [selectOptions]="ctrl.selectOptions"
            (selectedOption)="updateControlValue($event)">
          </app-radio-button-field>
        }

        @if (ctrl.type === 'select') {
          <app-select-field
            class="field"
            [name]="ctrl.name"
            [label]="ctrl.label"
            [value]="ctrl.value ?? ''"
            [customErrorMessage]="reportsForm.get(ctrl.name)?.hasError('required') && submitCount > 0 ? ctrl.label + ' is required' : ''"
            [isRequired]="ctrl.required === true"
            [options]="ctrl.options"
            [multipleSelect]="ctrl.multiSelect === true"
            (selectEvent)="updateControlValue($event)">
          </app-select-field>
        }
      }
    }
  </fieldset>
  <div *ngIf="submitCount > 0 && reportsForm.errors?.['dependencyError'] as err" class="error-text form-error-msg">
    {{err.message}}
  </div>
  <app-button
    (buttonEvent)="submit()"
    [classNames]="'success'">
    {{submitButtonContent}}
  </app-button>

</form>
